import { render, staticRenderFns } from "./CreateNotificationView.vue?vue&type=template&id=218a8a4a&"
import script from "./CreateNotificationView.vue?vue&type=script&lang=js&"
export * from "./CreateNotificationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports